import { useAuthentication } from "@app/store/useAuthtentication";
import { useQuery } from "@tanstack/react-query";
import {
  getAccountingNoteElectronicPdfService,
  getAccountingNotesService,
  getReturnAccountingVoucherService
} from "./accountingNotes";
import type { IAccountingNotesFilters, IReturnAccountingVoucherParams } from "./types";

export function useGetAccountingNotes(filters: IAccountingNotesFilters, enabled = true) {
  const token = useAuthentication((state) => state.auth.dataBiowel.token);

  return useQuery({
    enabled,
    gcTime: 0,
    queryKey: [
      "accountingNotes",
      filters.startDate,
      filters.endDate,
      filters.page,
      filters.perpage,
      filters.noteType,
      filters.search
    ],
    queryFn: async () => await getAccountingNotesService(filters, token)
  });
}

export function useGetAccountingNoteElectronicPdf(invNoteId: number, enabled = true) {
  const token = useAuthentication((state) => state.auth.dataBiowel.token);

  return useQuery({
    enabled,
    gcTime: 0,
    queryKey: ["accountingNoteElectronicPdf", invNoteId],
    queryFn: async () => await getAccountingNoteElectronicPdfService(invNoteId, token)
  });
}

export function useGetReturnAccountingVoucher(params: IReturnAccountingVoucherParams) {
  const token = useAuthentication((state) => state.auth.dataBiowel.token);

  return useQuery({
    enabled: false,
    gcTime: 0,
    queryKey: ["returnAccountingVoucher", params.dateMin, params.dateMax, params.siteId],
    queryFn: async () => await getReturnAccountingVoucherService(params, token)
  });
}
